import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <rect
      width={2}
      height={16}
      x={17.172}
      y={6.173}
      fill="#111"
      rx={1}
      transform="rotate(45 17.172 6.173)"
    />
    <rect
      width={2}
      height={16}
      x={18.552}
      y={17.075}
      fill="#111"
      rx={1}
      transform="rotate(135 18.552 17.075)"
    />
  </svg>
)
export default SvgComponent
